import { useEffect } from 'react';

export const useSyncDisplayedDate = (displayDates: Date, setDisplayedDate?: (date: Date) => void) => {
    useEffect(() => {
        if (setDisplayedDate) {
            setDisplayedDate(displayDates);
        }
    }, [displayDates, setDisplayedDate]);
};
